<div class="module-loader" *ngIf="enabled">
  <img src="assets/images/loading.gif" class="loading d-flex mx-auto" alt="">
</div>